import { HTML_BLANK_LINE, PLAIN_TEXT_BLANK_LINE } from './constants';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { HtmlSanitizer } from 'roosterjs-html-sanitizer';

const getHtmlBodyContent = (header: string, body: string): string => {
    const cssSanitizedBody = HtmlSanitizer.convertInlineCss(body);
    const userConfiguration = getUserConfiguration();
    const options = userConfiguration.UserOptions;
    const newHeader = options.AutoAddSignatureOnReply ? header : HTML_BLANK_LINE + header;

    return newHeader + cssSanitizedBody;
};

const getTextBodyContent = (header: string, body: string): string => {
    const newLine = PLAIN_TEXT_BLANK_LINE;
    return newLine + newLine + header + body;
};

/**
 * Insert header and quoted body to build raw editor content.
 */
const buildEditorContent = (isHtml: boolean, body: string, header: string): string => {
    return isHtml ? getHtmlBodyContent(header, body) : getTextBodyContent(header, body);
};

export default buildEditorContent;
